"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Footer = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var Layout_1 = require("../Layout");
var Footer = function (_a) {
    var props = __rest(_a, []);
    return (jsx_runtime_1.jsx("footer", __assign({ className: "m-0 py-5 " + props.className }, props, { children: jsx_runtime_1.jsx(Layout_1.Layout, __assign({ row: "my-3" }, { children: props.children }), void 0) }), void 0));
};
exports.Footer = Footer;
// eslint-disable-next-line react/display-name
exports.Footer.List = function (_a) {
    var props = __rest(_a, []);
    return (jsx_runtime_1.jsx("div", __assign({ className: "col" }, props, { children: jsx_runtime_1.jsx("ul", __assign({ className: "list-unstyled list-spaced" }, { children: props.children }), void 0) }), void 0));
};
//# sourceMappingURL=index.js.map